class popupModal extends HTMLElement {
	constructor() {
		super();
		this.modal = this;
		this.modalCloseButton = this.querySelector('.close');
		this.html = document.querySelector('html');
		this.body = document.querySelector('body');
		this.window = window;
	}

	connectedCallback() {
		this.bindEvents();
	}

	bindEvents() {
		this.modalCloseButton?.addEventListener(
			'click',
			this.onClose.bind(this)
		);
		this.window.addEventListener('click', this.onOverlayClick.bind(this));
	}

	onOpen() {
		this.modal?.classList.add('active');
		this.html?.classList.add('scroll-locked');
		this.body?.classList.add('scroll-locked');
	}

	onClose() {
		this.modal?.classList.remove('active');
		this.html?.classList.remove('scroll-locked');
		this.body?.classList.remove('scroll-locked');
	}

	onOverlayClick(event) {
		if (event.target === this.modal) {
			this.onClose();
		}
	}
}
customElements.define('popup-modal', popupModal);

class ModalTrigger extends popupModal {
	constructor() {
		super();
	}

	connectedCallback() {
		this.addEventListener('click', () => this.onModalOpen());
	}

	onModalOpen() {
		this.modalId = this.getAttribute('target');
		this.popup = document.querySelector(`#${this.modalId}`);
		this.popup.onOpen();
	}
}

customElements.define('modal-trigger', ModalTrigger);

class ModalCloser extends popupModal {
	constructor() {
		super();
	}

	connectedCallback() {
		this.addEventListener('click', () => this.onModalClose());
	}

	onModalClose() {
		this.modalId = this.getAttribute('target');
		this.popup = document.querySelector(`#${this.modalId}`);
		this.popup.onClose();
	}
}

customElements.define('modal-closer', ModalCloser);
